module.exports = __webpack_public_path__ + "img/map_arrow.0407a8e7.png";